import { baseApi, Tag } from './base'

type SessionSettings = { inactivityTimeoutMinutes: number }

export const sessionSettingsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    updateSessionSettings: builder.mutation<SessionSettings, SessionSettings>({
      query: (body) => ({ url: '/settings/session/inactivity-timeout', method: 'PUT', body }),
      invalidatesTags: [Tag.SESSION_SETTINGS],
    }),
    getPublicSessionTimeout: builder.query<SessionSettings, void>({
      query: () => ({ url: '/settings/session/inactivity-timeout/public', method: 'GET' }),
      providesTags: [Tag.SESSION_SETTINGS],
    }),
  }),
  overrideExisting: false,
})
